import React, {Component} from "react";
import _ from "lodash";
import "./Status.css";
import store from "../../lib/store";
import IconButton from 'material-ui/IconButton';
import ActionHome from 'material-ui/svg-icons/action/home';
import Clear from 'material-ui/svg-icons/content/clear';


import 'whatwg-fetch';

require('es6-promise').polyfill();
window._ = _;

class Status extends Component {

    constructor(props) {
        super(props);
        this.state = {
            msg:null,
            this_user_id: this.props.id ? this.props.id : this.props.match.params.statusId,
        }
        /*
        this.state = {
            display: null,
            photoURL: null,
            is_logined: false,
            this_user_id: this.props.id ? this.props.id : this.props.match.params.userId,
            situp: null
        };
        fetch(`${config.firebase.functionURL}/user?id=${this.state.this_user_id}`).then(res => {
            return res.json();
        }).then(function (result) {
            this.setState({displayName: result.displayName, photoURL: result.photoURL})
        }.bind(this));
        store.subscribe(function () {
            this.setState({is_logined: store.getState().is_logined});
        }.bind(this))
        firebase.auth().onAuthStateChanged(function (user) {
            this.setState({is_logined: user === null ? false : true});
        }.bind(this));*/
    }


    componentWillUnmount() {
    }

    componentDidMount() {
        // window.history.pushState(null, null, `/status/${this.props.id}`);
    }


    render() {
        return <div className="Status" style={{
            // backgroundImage: `url(https://source.unsplash.com/collection/1085693/${window.innerWidth}x${window.innerHeight})`,
            width: '100vw',
            height: '100vh',
            backgroundSize: 'cover'
        }}>
            <IconButton
                style={{position:'absolute', left:0}}
                href="/"
            >
                <ActionHome />
            </IconButton>
            {this.props.match && this.props.match.params ? null : <IconButton
                iconStyle={{
                    width: 60,
                    height: 60
                }}
                style={{
                    width: 120,
                    height: 120,
                    padding: 30,
                    position: 'absolute',
                    right: 0,
                    top: 0
                }}
                onClick={function () {
                    store.dispatch({type: 'USER_PROFILE_CLOSE'});
                    window.history.back();
                }}
            >
                <Clear/>
            </IconButton>}
            <div className="status">
                <h1>{this.state.msg}</h1>
            </div>
        </div>
    }
}

export default Status;


// WEBPACK FOOTER //
// ./src/container/user/Status.js